<style lang="less" scoped>
// @import "./OrderDetail.less";
.order-detail {
  // padding-bottom: 50px;
  /deep/.el-card {
    border-radius: 0;
    border: none;
  }
  /deep/.el-card__header {
    padding: 10px 20px;
    border: none;
  }
  /deep/.el-card__body {
    padding: 10px 20px;
  }
  .order-info {
    margin-top: 10px;
  }
  .member-info {
    margin-top: 10px;
  }
  .product-info {
    margin-top: 10px;
    /deep/.el-card__body {
      padding: 0;
    }
  }
  .footer-button {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 12px 0;
    background: white;
    justify-content: flex-end;
    /deep/.el-button--medium {
      width: 80px;
      padding: 5px 0;
    }
  }
}
</style>
<template>
  <div class="order-detail flex col">
    <el-card class="order-info">
      <h3 slot="header">订单信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>订单号:</span>
          <span class="margin-left">{{ order.orderSn }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>下单时间:</span>
          <span class="margin-left">{{ order.region }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>订单状态:</span>
          <span class="margin-left">{{ getOrderStatus(order) }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc">
          <span>支付方式:</span>
          <span class="margin-left">{{ $enums.payments.label(order.payMethod) }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="member-info">
      <h3 slot="header">收货人信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>收货人:</span>
          <span class="margin-left">{{ order.consignee }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>手机号:</span>
          <span class="margin-left">{{ order.mobile }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc">
          <span>收货地址:</span>
          <span class="margin-left">{{ order.createdAt }}{{ order.address }}</span>
        </div>
      </div>
    </el-card>

    <el-card class="member-info" v-if="order.orderInvoices && order.orderInvoices.length">
      <h3 slot="header">发票信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>发票类型:</span>
          <span class="margin-left">{{order.invoiceName ? '企业 电子发票' : '个人 电子发票'}}</span>
        </div>
        <!-- <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>发票类型:</span>
          <span class="margin-left">{{ order.consignee }}</span>
        </div> -->
        <div class="flex row  padding-tb-sm flex-cc">
          <span>发票明细:</span>
          <div class="flex col margin-left" style="width:70%;">
            <div style="width:100%" class="flex row flex-sb" v-for="(item, index) in order.orderInvoices" :key="index">
              <div>{{ item.invoiceSn}}</div>
              <a :href="item.invoiceExportUrl" target="_blank">【查看发票】</a>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="member-info">
      <h3 slot="header">物流信息</h3>
      <div class="member-order-express-info" v-if="checkExpressInfo()">
        <div class="member-order-express-number">
          {{expressInfo.expressName}}&nbsp;&nbsp;&nbsp;快递单号：{{expressInfo.expressNumber}}
        </div>
        <div class="member-order-express-list">
          <div class="member-order-express-list-item" v-for="(express, index) of expressInfo.trackInfo" :key="index">
            <div class="member-order-express-item-line"></div>
            <div class="member-order-express-item-dot"></div>
            <div class="member-order-express-item-content">
              <div class="member-order-express-remark">{{express.remark}}</div>
              <div class="member-order-express-time">{{express.time}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="member-order-express-info" v-else>
        暂时没有快递日志记录
      </div>
    </el-card>
    <el-card class="product-info">
      <h3 slot="header">商品详情</h3>
      <OrderItem v-for="(orderProduct, index) of order.orderProducts" :key="index" :product="orderProduct"></OrderItem>
    </el-card>
    <el-card class="member-info" style="margin-bottom: 15px">
      <div class="flex row flex-sb padding-tb-sm">
        <span>商品金额</span>
        <span>¥{{ order.productAmount }}</span>
      </div>
      <div class="flex row flex-sb padding-tb-sm">
        <span>运费</span>
        <span>¥{{ order.shippingAmount }}</span>
      </div>
      <div class="flex row flex-sb padding-tb-sm">
        <span>优惠</span>
        <span>-¥{{ order.discountAmount }}</span>
      </div>
      <div class="flex row flex-sb padding-tb-sm">
        <span>订单金额</span>
        <span>¥{{ order.orderAmount }}</span>
      </div>
    </el-card>
    <!-- <div style="height:50px; background: #f4f4f4;"></div> -->
    <div class="footer-button flex row flex-all-center shadow" v-if="order.orderStatus !== 103">
      <div class="margin-lr-sm">
        <el-button type="primary" :disabled="disable" @click="payOrder(order)" v-if="showOrderPayment(order)"> 付款 <span>{{cancelTimeDesc}}</span></el-button>
        <el-button @click="cancelOrder(order)" v-if="showOrderPayment(order)">取消订单</el-button>
        <el-button type="primary" @click="receiveOrder(order)" v-if="showOrderReceive(order)">签收</el-button>
        <!-- <el-button v-if="isRefund" @click="gotoOrderRefundDetail(order)">退款详情</el-button> -->
        <el-button style="width: 100px" v-if="showOrderRefundProgress(order)" @click="gotoOrderRefundDetail(order)">查看退款进度</el-button>
        <!-- <el-button v-if="showOrderRefundProgress(order)" @click="cancelRefund">取消退款</el-button> -->
        <el-button v-if="showOrderRefund(order)" @click="gotoOrderRefund(order)">申请退款</el-button>
        <el-button style="width: 100px" v-if="showOrderRefundAndShop(order)" @click="gotoOrderRefund(order)">申请退货退款</el-button>
      </div>

    </div>
    <div style="height: 50px"></div>
  </div>
  <!-- <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <div
      slot="header"
      class="member-order-header"
    >
      <h2>订单详情</h2>
    </div>
    <el-card>
      <div
        slot="header"
        class="member-order-info-header"
      >
        <div>订单基本信息</div>
        <div>收货人信息</div>
        <div>发票信息</div>
      </div>
      <div class="member-order-info">
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            订单编号：{{order.orderSn}}
          </div>
          <div class="member-order-info-list-item">
            订单状态：{{getOrderStatus(order)}}
          </div>
          <div class="member-order-info-list-item">
            支付方式：{{$enums.payments.label(order.payMethod)}}
          </div>
          <div class="member-order-info-list-item">
            物流公司：{{expressInfo.expressName}}
          </div>
        </div>
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            收货人：{{order.consignee}}
          </div>
          <div class="member-order-info-list-item">
            收货地址：{{order.region}}{{order.address}}
          </div>
          <div class="member-order-info-list-item">
            手机：{{order.mobile}}
          </div>
        </div>
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            发票类型：个人 电子发票
          </div>
          <div class="member-order-info-list-item">
            发票抬头：{{order.consignee}}
          </div>
          <div class="member-order-info-list-item">
            发票内容：产品明细
          </div>
          <div
            class="member-order-info-list-item"
            v-if="order.orderStatus != $enums.orderStatus.CANCELLED && orderInvoice.invoiceExportUrl != ''"
          >
            已开票：<a
              target="_blank"
              class="member-order-invoice-url"
              :href="orderInvoice.invoiceExportUrl"
            >【查看发票】</a>
          </div>
        </div>
      </div>
    </el-card>
    <el-card>
      <div
        slot="header"
        class="member-order-info-header"
      >
        <div>物流信息</div>
      </div>
      <div
        class="member-order-express-info"
        v-if="checkExpressInfo()"
      >
        <div class="member-order-express-number">
          {{expressInfo.expressName}}&nbsp;&nbsp;&nbsp;快递单号：{{expressInfo.expressNumber}}
        </div>
        <div class="member-order-express-list">
          <div
            class="member-order-express-list-item"
            v-for="(express, index) of expressInfo.trackInfo"
            :key="index"
          >
            <div class="member-order-express-item-line"></div>
            <div class="member-order-express-item-dot"></div>
            <div class="member-order-express-item-content">
              <div class="member-order-express-remark">{{express.remark}}</div>
              <div class="member-order-express-time">{{express.time}}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="member-order-express-info"
        v-else
      >
        暂时没有快递日志记录
      </div>
    </el-card>
    <div class="member-order">
      <el-card>
        <div
          class="member-order-product-list-header"
          slot="header"
        >
          <div class="order-product-list-header">
            <div class="order-product-detailed">商品清单</div>
            <div class="order-product-number">数量</div>
            <div class="order-product-price">单价</div>
          </div>
          <div class="order-handle">操作</div>
        </div>
        <div class="member-order-list">
          <div class="order-product-list">
            <div
              class="order-product-item"
              v-for="(orderProduct, index) of order.orderProducts"
              :key="index"
            >
              <div class="order-product-detailed">
                <img
                  :src="orderProduct.image"
                  class="order-product-image"
                  alt=""
                >
                <div>{{orderProduct.productName}}</div>
              </div>

              <div class="order-product-number">
                {{orderProduct.number}}
              </div>
              <div class="order-product-price">
                ¥{{orderProduct.salePrice}}
              </div>
            </div>
          </div>
          <div class="order-payment">
            <el-button
              type="primary"
              :disabled="disable"
              @click="payOrder(order)"
              v-if="showOrderPayment(order)"
            >
              付款 <span>{{cancelTimeDesc}}</span>
            </el-button>
            <el-button
              style="margin-top:15px"
              type="text"
              v-if="showOrderPayment(order)"
              @click="cancelOrder(order, false)"
            >
              取消订单
            </el-button>
            <el-button
              type="primary"
              @click="receiveOrder(order)"
              v-if="showOrderReceive(order)"
            >
              签收
            </el-button>
            <div
              class="flex col flex-cc"
              v-if="showOrderRefundProgress(order)"
            >

              <router-link
                class="text-df"
                :to="{ name: 'member-order-refund-detail', params:{ id : order.id}}"
              >
                查看退款进度
              </router-link>
              <a
                @click="cancelRefund"
                class="text-df margin-top"
              >
                取消退款
              </a>
            </div>
            <router-link
              v-if="showOrderRefund(order)"
              class="text-df"
              :to="{ name: 'member-order-refund', params:{ id : order.id}}"
            >
              申请退款
            </router-link>
          </div>
        </div>
      </el-card>
      <div class="order-cost-information">
        <div class="order-cost-information-header">费用信息</div>
        <div>商品金额：¥{{order.productAmount}} + 配送费：¥{{order.shippingAmount}} = 订单金额：¥{{order.orderAmount}} 已支付：¥{{order.payStatus == $enums.payStatus.PAID ? order.orderAmount : '0.00'}}</div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import _ from 'lodash';
import { payOrder, getOrderStatus } from "@/helpers/index";

import OrderItem from './components/OrderItem'

const { mapState: authMapState } = createNamespacedHelpers('auth')
const { mapState, mapActions } = createNamespacedHelpers('refund')
export default {
  name: 'OrderDetail',
  components: {
    OrderItem
  },
  data() {
    return {
      order: {},
      cancelTime: 0,
      cancelTimeDesc: '',
      expressInfo: {
        'trackInfo': [],
        'expressName': '',
        'expressNumber': '',
      },
      disable: false,
      orderInvoice: {
        'invoiceExportUrl': ''
      },
      returnEnable: 0,
      refundEnable: 0
    }
  },
  methods: {
    ...mapActions(['changeRefundOrderStatus']),
    gotoOrderRefundDetail(order) {
      if (!order || !order.id) return
      this.$router.push({
        name: 'member-order-refund-detail',
        params: {
          id: order.id
        }
      })
    },
    gotoOrderRefund(order) {
      if (!order || !order.id) return
      this.$router.push({
        name: 'member-order-refund',
        params: {
          id: order.id
        }
      })
    },
    async cancelRefund() {
      try {
        await this.confirm('确定取消当前退款申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        await this.changeRefundOrderStatus({
          id: this.order.refundRecord.id,
          status: this.$enums.refundStatus.RO_CANCELLED
        })
        this.getOrder(this.order.id);
      } catch (error) {
        this.getOrder(this.order.id);
      }
    },

    checkExpressInfo() {
      if (this.expressInfo.trackInfo && this.expressInfo.trackInfo.length > 0) {
        return true;
      }
      return false;
    },
    getOrderStatus(order) {
      return getOrderStatus(this.$enums, order)
    },
    payOrder(order) {
      payOrder(this.$router, order)
    },

    /**
     * 获取订单
     */
    async getOrder(id) {
      this.order = await this.$store.dispatch('orders/document', id);
      this.order = this.order.document
      if (this.order.shippingStatus == this.$enums.shippingStatus.SHIPPED) {
        this.expressInfo = await this.$store.dispatch('express/document', { orderId: id });
      }
      this.getOrderInvoice();
      this.handleOrderCancelTime()
    },

    /**
     *  获取订单的发票信息
     */
    getOrderInvoice() {
      const orderInvoices = this.order.orderInvoices.reverse();
      for (var orderInvoice of orderInvoices) {
        if (orderInvoice.invoiceType == 'blue') {
          this.orderInvoice = orderInvoice;
          return;
        }
      }
    },

    /**
     * 是否显示支付链接
     */
    showOrderPayment(order) {
      if (order.orderStatus == this.$enums.orderStatus.CANCELLED || order.orderStatus == this.$enums.orderStatus.COMPLETED || order.payStatus != this.$enums.payStatus.UNPAID) {
        return false;
      } else {
        return true;
      }
    },

    /**
     * 取消订单
     */
    async cancelOrder(order, isConfirm) {
      if (!isConfirm) {
        await this.confirm('是否确认取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }
      await this.$store.dispatch('order/cancel', { id: order.id });
    },
    /**
     * 是否显示签收按钮
     */
    showOrderReceive(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING &&
        order.shippingStatus == this.$enums.shippingStatus.SHIPPED &&
        order.payStatus == this.$enums.payStatus.PAID) {
        return true
      }
      return false
    },
    async receiveOrder(order, isConfirm) {
      if (!isConfirm) {
        await this.confirm('确认签收当前订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }

      await this.$store.dispatch('order/receive', { id: order.id });
      this.getOrder(order.id)
    },

    /**
   * 是否显示申请退款按钮
   */
    showOrderRefund(order) {
      if (order.orderStatus == this.$enums.orderStatus.ACCEPTED && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.UNSHIPPED && this.refundEnable) {
        return true;
      }
      return false
    },
    showOrderRefundAndShop(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.SHIPPED && this.returnEnable && order.can_refund) {
        return true;
      }
      if (order.orderStatus == this.$enums.orderStatus.COMPLETED && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.SIGN && this.returnEnable && order.can_refund) {
        return true;
      }
      return false
    },
    /**
     * 是否显示查看退款进度
     */
    showOrderRefundProgress(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING && order.refundRecord) {
        return true
      }
      return false
    },

    /**
     * 处理订单自动关闭时间
     */
    handleOrderCancelTime() {
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if (orderCancelTime == 0 || order.orderStatus != this.$enums.orderStatus.UNSETTLED) {
        this.cancelTimeDesc = '';
        return;
      }

      setInterval(this.getOrderCancelTime, 1000)

    },

    /**
     * 订单自动关闭时间
     */
    getOrderCancelTime() {
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if (this.cancelTime != 0) {
        orderCancelTime = this.cancelTime--;
      } else {
        let currentTime = new Date().getTime();
        let orderCreateTime = new Date(order.createdAt).getTime()
        orderCancelTime = parseInt(orderCancelTime) - (currentTime - orderCreateTime)

        if (orderCancelTime <= 0) {
          this.cancelTimeDesc = ''
          this.cancelTime = 0
          this.disable = true;
          return
        }
        orderCancelTime = orderCancelTime / 1000
        this.cancelTime = parseInt(orderCancelTime)
      }

      let minutes = parseInt(orderCancelTime / 60)
      let seconds = parseInt(orderCancelTime % 60)

      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      this.cancelTimeDesc = minutes + ":" + seconds;
    },
  },
  mounted() {
    const orderId = this.$route.params.id
    this.getOrder(orderId);
    this.returnEnable = localStorage.getItem('activity') ? JSON.parse(localStorage.getItem('activity')).returnEnable : 0
    this.refundEnable = localStorage.getItem('activity') ? JSON.parse(localStorage.getItem('activity')).refundEnable : 0
  },
  updated() {
  },
  computed: {
  },
  watch: {

  }
};
</script>


